import { ReactElement, useState } from 'react';

type SignatureFrameProps = {
  src: string;
};

export function SignatureFrame({ src }: SignatureFrameProps): ReactElement {
  const [loading, setLoading] = useState(true);
  const [frameKey, setFrameKey] = useState(0);

  function reloadFrame() {
    setLoading(true);
    setFrameKey(prev => prev + 1);
  }

  function openExternal() {
    window.open(src, '_blank', 'noopener,noreferrer');
  }

  return (
    <section className="w-full">
      <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
        <span className="font-bold text-red-600">
          Aguarde a confirmação da assinatura para prosseguir.
        </span>

        <div className="flex gap-2">
          <button type="button" onClick={reloadFrame}>
            Recarregar
          </button>

          <button type="button" onClick={openExternal}>
            Abrir em nova aba
          </button>
        </div>
      </div>

      <div className="relative w-full overflow-hidden rounded-md border border-gray-200 bg-white">
        {loading && (
          <div className="absolute inset-0 z-10 flex items-center justify-center bg-white">
            Carregando documento...
          </div>
        )}

        <iframe
          key={frameKey}
          src={src}
          title="Documento para assinatura"
          className="block w-full h-[calc(100vh-220px)] min-h-[600px] border-0"
          loading="eager"
          referrerPolicy="strict-origin-when-cross-origin"
          allow="clipboard-read; clipboard-write"
          sandbox="allow-forms allow-scripts allow-same-origin allow-popups allow-downloads"
          onLoad={() => setLoading(false)}
        />
      </div>
    </section>
  );
}
